import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { METRES_PER_FOOT } from 'utils/unitConverter/conversionFactors'
import type { TUnitConverterOptionsWithUnits, TUnitConverterTypicalReturn } from 'utils/unitConverter/types'

type TRowSpacingUnit = 'ft' | 'm'

const DEFAULT_DECIMAL_PLACES = 1
const METRES_IN: Record<TRowSpacingUnit, number> = { ft: METRES_PER_FOOT, m: 1 }

export const rowSpacing: Record<
  'rowSpacing',
  (
    spacing?: number | null,
    options?: TUnitConverterOptionsWithUnits<TRowSpacingUnit>,
  ) => TUnitConverterTypicalReturn
> = {
  rowSpacing: (
    spacing: number | null = null,
    {
      decimalPlaces = DEFAULT_DECIMAL_PLACES,
      inputUnit = 'm',
      outputUnit = userDetailsStore.getState().rain === 'IMPERIAL' ? 'ft' : 'm',
    }: TUnitConverterOptionsWithUnits<TRowSpacingUnit> = {},
  ) => {
    const convertedValue = isNil(spacing) ? null : (spacing * METRES_IN[inputUnit]) / METRES_IN[outputUnit]
    const measurement = outputUnit === 'ft' ? translate.measurements.feet : translate.measurements.meters
    const unitSymbol = measurement.unit()
    const label = translate.phrases.banyanApp('Row spacing')

    return {
      categoryTitle: () => translate.phrases.templates('{{label}} ({{unitSymbol}})', { label, unitSymbol }),
      categoryTitleWithoutUnit: () => label,
      defaultNumberOfDecimalPlaces: () => DEFAULT_DECIMAL_PLACES,
      suffix: () => unitSymbol,
      shortTitle: () => label,
      title: () => translate.phrases.templates('{{label}} ({{unitSymbol}})', { label, unitSymbol }),
      titleWithoutUnit: () => label,
      value: () => (isNil(convertedValue) ? null : +convertedValue.toFixed(decimalPlaces)),
      valueAsString: () => measurement.value(convertedValue, decimalPlaces),
      valueWithSuffix: () => measurement.valueWithUnit(convertedValue, decimalPlaces),
      valueWithNoRounding: () => convertedValue,
    }
  },
}
